export const ACTIVE_PRODUCT_MESSAGE = 'Ao ativar este produto, o mesmo será mostrado no catálogo.';
export const DEACTIVE_PRODUCT_MESSAGE = 'Ao desativar este produto, o mesmo não será mostrado no catálogo.';
